import { FC } from 'react'

type ProfileImageProps = {
  className?: string
  firstName?: string
  lastName?: string
  pictureUrl: string | null
  size?: number
  variant?: 'circle' | 'square'
  onClick?: () => void
}

const ProfileImage: FC<ProfileImageProps> = ({ className, firstName, lastName, pictureUrl, size = 35, variant = 'square', onClick }) => {
  const initials = `${firstName?.[0]}${lastName?.[0]}`.toUpperCase()
  const imageShapeClassName = `rounded${variant === 'circle' ? '-circle' : ''}`

  return (
    <span>
      {pictureUrl ? (
        <img
          onClick={onClick}
          className={`${imageShapeClassName} ${className}`}
          src={`${pictureUrl}`}
          alt="Profile picture"
          style={{ height: size, width: size }}
          data-testid="profile-image"
          role="button"
        />
      ) : (
        <InitialsProfileImage
          initials={initials}
          className={className}
          size={size}
          imageShapeClassName={imageShapeClassName}
          data-testid="initials-profile-image"
        />
      )}
    </span>
  )
}

type InitialsProfileImageProps = {
  className?: string
  initials: string
  size: number
  imageShapeClassName: string
}

const InitialsProfileImage: FC<InitialsProfileImageProps> = ({ initials, className, imageShapeClassName, size, ...rest }) => {
  return (
    <div className={`${imageShapeClassName} ${className} overflow-hidden`} style={{ height: size, width: size }} {...rest}>
      <svg viewBox="0 0 100 100">
        <rect x="0" y="0" width="100%" height="100%" rx="0" ry="0" opacity="100%" fill="#e9ecef"></rect>
        <text x="50%" y="50%" fontSize="55" textAnchor="middle" fill="#495057" style={{ fontWeight: 'bold', dominantBaseline: 'central' }}>
          {initials}
        </text>
      </svg>
    </div>
  )
}

export default ProfileImage
